export default function componentInstanceId(prefix) {
  let id = 1
  return {
    beforeCreate() {
      this.$id = `${prefix || this.$options.name || 'component'}-${id++}`
    },
  }
}
